<template>
  <section class="attachment-panel">
    <div class="attachment-head">
      <p class="attachment-title">Post to this event</p>
      <p class="attachment-subtitle">Choose a type only if needed</p>
    </div>

    <div class="attachment-list">
      <div v-for="item in items" :key="item.key" class="attachment-item">
        <div class="attachment-copy">
          <div class="attachment-label">
            <i class="attachment-icon" :class="item.iconClass" aria-hidden="true"></i>
            <span>{{ item.title }}</span>
          </div>
          <p class="attachment-desc">{{ item.description }}</p>
        </div>

        <label class="toggle" :aria-label="item.title">
          <input
            type="checkbox"
            :checked="model[item.key]"
            @change="onToggle(item.key, $event)"
          />
          <span class="toggle-track"></span>
        </label>
      </div>
    </div>
  </section>
</template>

<script setup>
/* eslint-disable no-undef */
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:modelValue'])

const defaults = {
  textPhoto: false,
  schedule: false,
  poll: false,
  carPool: false
}

const model = computed(() => ({
  ...defaults,
  ...props.modelValue
}))

const items = [
  {
    key: 'textPhoto',
    iconClass: 'fas fa-image',
    title: 'Text & Photo',
    description: 'Send your wishes using a message, a photo, or both'
  },
  {
    key: 'schedule',
    iconClass: 'fas fa-pen',
    title: 'Schedule',
    description: 'Please choose your preferred date and time for scheduling'
  },
  {
    key: 'poll',
    iconClass: 'fas fa-chart-bar',
    title: 'Poll',
    description: 'Poll questions are powerful for instantly engaging any audience'
  },
  {
    key: 'carPool',
    iconClass: 'fas fa-car',
    title: 'Car Pool',
    description: 'Carpooling is a shared ride system where two or more people traveling in the same direction use one car together'
  }
]

const onToggle = (key, event) => {
  emit('update:modelValue', {
    ...model.value,
    [key]: event.target.checked
  })
}
</script>

<style scoped>
.attachment-panel {
  border-radius: 16px;
  border: 1px solid #f3e8ee;
  background: linear-gradient(180deg, #fff7f8 0%, #ffffff 70%);
  padding: 16px;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.06);
}

.attachment-head {
  margin-bottom: 12px;
}

.attachment-title {
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 2px;
}

.attachment-subtitle {
  color: #64748b;
  font-size: 0.9rem;
  margin-bottom: 0;
}

.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px 14px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid #f1f5f9;
}

.attachment-copy {
  min-width: 0;
}

.attachment-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  color: #0f172a;
}

.attachment-icon {
  color: #f472b6;
  font-size: 1rem;
}

.attachment-desc {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.85rem;
}

.toggle {
  position: relative;
  width: 46px;
  height: 26px;
  flex-shrink: 0;
}

.toggle input {
  display: none;
}

.toggle-track {
  position: absolute;
  inset: 0;
  background: #e2e8f0;
  border-radius: 999px;
  transition: background 0.2s ease;
}

.toggle-track::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  top: 3px;
  left: 3px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(15, 23, 42, 0.15);
  transition: transform 0.2s ease;
}

.toggle input:checked + .toggle-track {
  background: #f472b6;
}

.toggle input:checked + .toggle-track::before {
  transform: translateX(20px);
}

@media (max-width: 576px) {
  .attachment-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .toggle {
    align-self: flex-end;
  }
}
</style>
